import React from 'react';
import { Stack, Icon, Typography } from '@mui/material';

//activos
import PersonCheckIcon from '../../../../Activos/Icons/PersonCheckIcon';

/**
 * 
 * @param {{ fontSize:number, textTitle:string }} param0 
 * @returns 
 */
export const TitleComponent = ({ fontSize, textTitle }) => {
  return (
    <Stack marginTop={"20px"} display={"flex"} sx={{ height: "38px", gap:"8px", width: "100%"}} alignItems={"center"} flexDirection={"row"} justifyContent={"center"}>
      <Icon>
        <PersonCheckIcon/>
      </Icon>
      
      <Typography sx={{ color:"#082478", fontWeight:500, fontSize: fontSize }}>
         {textTitle}
      </Typography>

    </Stack>
   )
}
